module.exports = __webpack_public_path__ + "img/population.a93569ac.png";